<template>
  <div class="des-box">
    <p class="des-title">{{title}}</p>
    <div class="des-content">
        <slot></slot>
    </div>
  </div>
</template>

<script>
export default {
    name: 'descBox',
    props: {
        title: String
    },
    data() {
        return {

        };
    }
};
</script>

<style  lang="scss" scoped>
.des-box{
    padding: 24px 18px;
    margin: 0 16px 10px;
    background-color: #fff;
    border-radius: 12px;
    text-align: left;
    .des-title{
        height: 16px;
        font-size: 16px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: #242934;
        line-height: 16px;
        margin-bottom: 14px;
    }
    .des-content{
        font-size: 14px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #646B7A;
        line-height: 20px;
    }
}
</style>
